/** @format */

import { Injectable, inject } from '@angular/core';
import { AuthenticationService } from '@shared/authentication/data-access';

@Injectable({ providedIn: 'root' })
export class BuyNowService {
  private readonly authenticationService = inject(AuthenticationService);

  private readonly buyNowLoginParam = 'showBuyNow' as const;
  private readonly colorParam = 'color' as const;

  signInForBuyNow(sku: string, shipMode: string, quantity: number): void {
    let returnUrl: string;
    try {
      const url = new URL(globalThis.location.href);
      url.searchParams.delete(this.colorParam);
      url.searchParams.set(this.buyNowLoginParam, 'true');
      url.searchParams.set('sku', sku);
      url.searchParams.set('shipMode', shipMode);
      url.searchParams.set('quantity', `${quantity}`);
      returnUrl = url.href;
    } catch {
      returnUrl = '/';
    }

    this.authenticationService.login({ target: returnUrl });
  }

  hasBuyNowLoginParam(): boolean {
    try {
      return new URL(globalThis.location.href).searchParams.get(this.buyNowLoginParam) === 'true';
    } catch {
      return false;
    }
  }

  removeBuyNowLoginParam(): void {
    try {
      const url = new URL(globalThis.location.href);
      url.searchParams.delete(this.buyNowLoginParam);
      globalThis.history.replaceState(null, '', url.toString());
    } catch {
      return;
    }
  }
}
